<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Approve Submitted Hours</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <vs-divider class="m-5" />
      <template v-for="(approvalHours, index) in approveSubmittedHours">


        

        


        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span> Campaign Name:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ approvalHours.campaign_name }}
          </div>



          <div class="vx-col sm:w-1/5 w-full">
            <span> Submit Type:</span> {{ approvalHours.submit_type }}
          </div>
       


        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span> Campaign Code:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            {{ approvalHours.campaign_code }}
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            Sales Developer : {{ approvalHours.sales_developer_name }}
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            Date : {{ approvalHours.formatted_date }}
          </div>

         <template v-if="approvalHours.submit_type != 'Late submission of hours'">

          <div class="vx-col sm:w-1/5 w-full">
            Original Hour : {{ approvalHours.previous_hour }}
          </div>
          <div class="vx-col sm:w-1/5 w-full">
            Updated Hour : {{ approvalHours.hours }}
          </div>


          </template>

            <template v-else>
              
              <div class="vx-col sm:w-1/5 w-full">  </div>
              <div class="vx-col sm:w-1/5 w-full">  </div>
              </template>


          <div class="vx-col sm:w-1/5 w-full">
            <vs-checkbox v-model="approvalHours.approved" name="approved"
              >Approve</vs-checkbox
            >
            <br />
            <vs-checkbox v-model="approvalHours.declined" name="declined"
              >Decline</vs-checkbox
            >
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Client Billable Hours:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <flat-pickr
                :config="configTimePicker"
                v-model="approvalHours.client_billable_hours"
                name="approvalHours"
              />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Comments:</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-textarea v-model="approvalHours.comments" />
          </div>
          <div class="vx-col sm:w-1/4 w-full">
            <vs-button @click="submitApproval(index)" color="primary"
              >Submit</vs-button
            >
          </div>
        </div>

        <vs-divider class="m-5" />
      </template>
    </vx-card>
  </div>
</template>

<script>
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import defineAbilitiesFor from "@/config/abilities";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  data() {
    return {
      configTimePicker: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H.i",
        time_24hr: true,
        minTime: "00:00",
        maxTime: "23:00"
      },
      user_id: null,
      user_role: null,
      abilities: null,
      approveSubmittedHours: []
    };
  },
  components: {
    moduleCampaignManagement,
    flatPickr
  },
  methods: {
    accept(){
        return false
    },
    submitApproval(index) {

      let newArray = [];
      newArray.push(this.approveSubmittedHours[index]);

      if(this.approveSubmittedHours[index].approved == true && this.approveSubmittedHours[index].declined == true){
            this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Alert`,
        text:
          "Please choose either approved or declined",
        accept: this.accept,
        acceptText: "Ok"
      });
        return false
      }
      this.$vs.loading();

      this.approveSubmittedHours = newArray;

      let self = this;
      this.approveSubmittedHours.map(ele => {
        ele.user_id = self.user_id;
      });
      let declined = self.approveSubmittedHours.filter(function(ele) {
        return ele.declined == true;
      });
      if (declined != 0) {


        if (self.approveSubmittedHours[0].submit_type == 'Late submission of hours') {


          this.$store
          .dispatch("campaignsManagement/declineExceed15WorkingHours", declined)
          .then(res => {
            console.log(res);
            if (res.data.status == "success") {
              this.$vs.notify({
                color: "success",
                title: "Working Hours",
                text: res.data.message
              });
              this.$vs.loading.close();

              this.$router.go(0)
            }
          })
          .catch(err => {
            console.log(err);
          });

        }else{


          this.$store
          .dispatch("campaignsManagement/declineWorkingHours", declined)
          .then(res => {
            console.log(res);
            if (res.data.status == "success") {
              this.$vs.notify({
                color: "success",
                title: "Working Hours",
                text: res.data.message
              });
              this.$vs.loading.close();

              this.$router.go(0)
            }
          })
          .catch(err => {
            console.log(err);
          });

        }




     
      }

      self.approveSubmittedHours = self.approveSubmittedHours.filter(function(
        ele
      ) {
        return ele.approved == true;
      });
      if (self.approveSubmittedHours.length == 0) {
        return;
      }



      if (self.approveSubmittedHours[0].submit_type == 'Late submission of hours') {
        self.$store
        .dispatch(
          "campaignsManagement/approveExceed15WorkingHours",
          self.approveSubmittedHours
        )
        .then(res => {
          console.log(res);
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Working Hours",
              text: res.data.message
            });
                          this.$vs.loading.close();

            this.$router.go(0)

            // this.$router.push({ path: "/dashboard" });
          }
        })
        .catch(err => {
          console.log(err);
        });
      }else{
        self.$store
        .dispatch(
          "campaignsManagement/approveWorkingHours",
          self.approveSubmittedHours
        )
        .then(res => {
          console.log(res);
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Working Hours",
              text: res.data.message
            });
                          this.$vs.loading.close();

                          self.$router.go(0)

            // this.$router.push({ path: "/dashboard" });
          }
        })
        .catch(err => {
          console.log(err);
        });
      }

    
    },
    fetchApprovalSubmitHours() {
      let filter = {};
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      this.$store
        .dispatch("campaignsManagement/fetchApprovalSubmitHours", filter)
        .then(res => {
          this.approveSubmittedHours = JSON.parse(res.data);


          console.log("sadasdasdasdasd",this.approveSubmittedHours);




          // this.approveSubmittedHours.map(ele => ele.client_billable_hours = ele.hours)
          this.approveSubmittedHours.map(ele => {
            ele.formatted_date = moment(ele.date).format("DD/MM/YYYY");
            ele.client_billable_hours = ele.hours
          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.resetPassword();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    resetPassword() {
      this.$vs.loading();
      this.$store
        .dispatch("userManagement/resetPassword", this.approveSubmittedHours)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Password Reset",
              text: res.data.message
            });
            this.$router.push({ path: "/login" });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Password Reset",
              text: res.data.message
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  },
  mounted() {
    // this.approveSubmittedHours.token = this.$route.params.token;
    // console.log(this.approveSubmittedHours.token);
    this.fetchApprovalSubmitHours();
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
